export const TRIGGER_VALIDATION_FIELDS_OPTIONS = [
  { value: 'BONUS_LEVEL', label: 'Nível de bônus' },
  { value: 'INSURED_DOCUMENT', label: 'Documento do segurado' },
  { value: 'DRIVER_DOCUMENT', label: 'Documento do condutor' },
  { value: 'CEP_OVERNIGHT', label: 'CEP de pernoite' },
  { value: 'PLATE', label: 'Placa' },
  { value: 'CHASSI', label: 'Chassi' },
  { value: 'FIPE_CODE', label: 'Código FIPE' },
];
